// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3qJpX","content":"ManualTimeModal_content__2WCdo"};